import React, { useContext, useEffect, useRef, useState } from "react";
import styles from './ProductListingDetails.module.scss';
import tshirt from "../../../assets/images/dummyImages/t-shirt-1.jpg";
import SimilarProducts from "./SimilarProducts";
import {
  DescRating,
  DescSold,
  DescVisitStore,
  DesDeliver,
  DesDeliverText,
  DetCouponApply,
  DetProdItem,
  DetProdTitle,
  DetTitle,
  FilterH,
  LiveOrgPrice,
  LiveProdName,
  LiveVisitStore,
  NewsLetterP,
  NewsLetterStyle,
  RowButton,
  RowPrice,
  RowPriceOrange,
  RowProdDesc,
  RowStarReviews,
} from "../../../StyledComponents";
import { Card, Col, Row } from "reactstrap";
import placeHolder from "../../../assets/images/image-place-holder.png";
import ImageMagnifier from "../../Manage/ImageMagnifier";
import { getImageURL } from "../../../snippets/snippets";
import Rating from "react-rating";
import { Star } from "react-feather";
import { ThemeColors } from "@src/utility/context/ThemeColors";
import { LuTicket } from "react-icons/lu";
import { FaAngleDown } from "react-icons/fa6";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import coupon from "../../../assets/images/images/coupon.png";
import delivery from "../../../assets/images/images/free-delivery.png";
import ProductListingDesc from "./ProductListingDesc";
import { CiHeart, CiShare2, CiCircleCheck } from "react-icons/ci";
import { AiOutlineLike } from "react-icons/ai";
import { FaPinterest, FaFacebook } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { IoMdLink } from "react-icons/io";
import mail from '../../../assets/images/icons/gmail.svg'
import PeekOtherCategories from "../../Manage/PeekOtherCategories";
import ProductsYouMayLike from "../../Manage/ProductsYouMayLike";
import shoe from '../../../assets/images/dummyImages/shoe.png'
import shorts from '../../../assets/images/dummyImages/shorts.png'
import shirt from '../../../assets/images/dummyImages/shirt.png'
import cap from '../../../assets/images/dummyImages/cap.png'
import { PiKeyReturnThin } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { getProductById } from '../../../utility/api/services/Products/ProductSlice'
import Skeleton from 'react-loading-skeleton'
import ProductSkeletonLoader from "../../../@core/components/spinner/ProductSkeletonLoader";

const ProductListingDetails = () => {
  const themeColors = useContext(ThemeColors);


  const [product, setProduct] = useState(-1);
  const [image, setImage] = useState("");
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null); // Initialize state for selected size

  const [quantity, setQuantity] = useState(1);

  const [selectedPromo, setSelectedPromo] = useState("promotions"); // Default to promotions

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [variation, setVariation] = useState(null)


  const dispatch = useDispatch()
  let productId = "6719dee56c6592b0198e9d4a"
  const { product: fetchedProduct, isLoading, error } = useSelector((state) => state.product);


  useEffect(() => {

    dispatch(getProductById(productId))

  }, [])


  useEffect(() => {
    if (fetchedProduct) {
      setVariation(fetchedProduct.variations[0])
    }

  }, [fetchedProduct])


  // console.log("variation: ", variation);




  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const copyLink = () => {
    const linkToCopy = window.location.href; // Change this to the link you want to copy
    navigator.clipboard.writeText(linkToCopy).then(() => {
      alert('Link copied to clipboard!');
    });
  };


  const [popoverOpen, setPopoverOpen] = useState(false);
  const popoverRef = useRef(null);
  const toggleRef = useRef(null);

  const togglePopover = () => {
    setPopoverOpen((prev) => !prev);
  };

  const handlePromoChange = (filter) => {
    setSelectedPromo(filter);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      toggleRef.current &&
      !toggleRef.current.contains(event.target)
    ) {
      setPopoverOpen(false);
    }
  };

  // Add event listener for clicks outside
  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeDialog = () => {
    dialogRef.current.close();
  };

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1)); // Prevent going below 1
  };

  const isAvailable = (size) => {
    const availableSizes = ["small", "medium"]; // Define available sizes
    return availableSizes.includes(size);
  };

  const handleSizeSelection = (size) => {
    setSelectedSize(size); // Update selected size
  };

  const sizeNames = {
    small: variation?.attributes?.size || "Small",
    medium: "Medium",
    large: "Large",
  };

  const colorNames = {
    "#FF5733": "Red-Orange",
    "#33FF57": "Green",
    "#5733FF": "Blue",
    "#FF33FF": "Pink",
    "#FFFF33": "Yellow",
    // Add more color codes and names as needed
  };
  const changeImage = (variation) => {
    setVariation(variation)
    // setImage(img);
  };

  const handleColorSelection = (color) => {
    setSelectedColor(color);
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollElement = scrollRef.current;

    const handleScroll = (event) => {
      event.preventDefault();
      scrollElement.scrollLeft += event.deltaY; // Moves horizontally on vertical scroll
    };

    if (scrollElement) {
      scrollElement.addEventListener("wheel", handleScroll);
    }

    // Clean up the event listener on component unmount
    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("wheel", handleScroll);
      }
    };
  }, []);


  const Peeks = [
    {
      img: shoe,
      name: "Sneakers Shoes"
    },
    {
      img: shorts,
      name: "Pants and Shorts"
    },
    {
      img: shirt,
      name: "Full sleeve shirts"
    },
    {
      img: cap,
      name: "Caps"
    },
  ]


  const products = [
    {
      id: 1,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 2,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 3,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description:
        "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 4,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description:
        "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 5,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description:
        "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
    {
      id: 6,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 7,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 8,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description:
        "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 9,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description:
        "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 10,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description:
        "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
    {
      id: 11,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 12,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 13,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description:
        "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 14,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description:
        "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 15,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description:
        "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
  ];

  // Sample delivery options
  const deliveryOptions = [
    { type: 'Standard', price: '$', deliveryTime: '3-5 days' },
    { type: 'Economy', price: '$', deliveryTime: '2-4 days' },
    { type: 'Express', price: '$', deliveryTime: '1-2 days' },
  ];

  const [selectedOption, setSelectedOption] = useState(null); // Keep track of the selected option

  const handleOptionClick = (optionType) => {
    setSelectedOption(optionType); // Set the selected option directly
  };

  console.log("fetched Product:::", fetchedProduct);


  if (isLoading) return <ProductSkeletonLoader />

  if (error) {
    return <div style={{ padding: '20px', display: 'flex', flexDirection: 'row', height: '80vh', width: '100%', justifyContent: "center" }}>Error: {error.message}</div>;
  }

  return (
    <>
      <div className={styles.mainContainer}>
        <div>
          <Row className={styles.productDetailsContainer}>

            <Col
              // style={{
              //   width: "80%",
              //   // border: "1px solid red",
              //   // marginRight: "35px",
              // }}
              lg={9}
            >
              <Row className="m-0">
                <Col xl="6" lg="12" md="12" sm="12" xs="12">
                  <ImageMagnifier
                    height={"517px"}
                    src={fetchedProduct?.productImages?.[0]}
                  />
                  <div
                    ref={scrollRef}
                    style={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "thin" /* Firefox */,
                      scrollbarColor:
                        "#888 #f1f1f1" /* Custom scrollbar color in Firefox */,
                      textAlign: 'center',
                    }}
                    className="pt-2 flex products-scroll"
                  >
                    {fetchedProduct?.variations?.length > 0 ? (
                      fetchedProduct?.variations?.map((variation, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => changeImage(variation)}
                            style={{
                              height: "83px",
                              width: "93px",
                              borderRadius: "20px",
                              display: "inline-block",
                              marginRight: "10px",
                              padding: "0.5rem",
                              backgroundColor: "#f2f2f2",
                            }}
                            className=" cursor-pointer flex items-center"
                          >
                            <img
                              style={{
                                height: "100%",
                                width: "100%",
                                borderRadius: "10px",
                              }}
                              src={variation.image || 'https://placehold.co/24x24?text=Maelano'}
                              alt={variation.name}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          height: "83px",
                          width: "93px",
                          borderRadius: "20px",
                          display: "inline-block",
                          marginRight: "10px",
                          padding: "0.5rem",
                          backgroundColor: "#f2f2f2",
                        }}
                        className=" cursor-pointer flex items-center"
                      >
                        <img
                          style={{
                            height: "100%",
                            width: "100%",
                            borderRadius: "20px",
                          }}
                          src={placeHolder}
                          alt="placeholder"
                        />
                      </div>
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="12" md="12" sm="12" xs="12">
                  <div className={styles.detailsContainer}>
                    <DetProdTitle>{fetchedProduct?.title || <Skeleton />}</DetProdTitle>
                    {variation !== null ? (
                      <div className={styles.productInfo}>
                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div className="d-flex align-items-center">
                              <RowPriceOrange>{variation?.discountedPrice}$</RowPriceOrange> &nbsp; &nbsp;
                              <RowPrice>
                                <strike>{variation?.price}$</strike>
                              </RowPrice>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Rating
                                readonly={true}
                                initialRating={variation?.ratings || 3}
                                emptySymbol={
                                  <Star size={18} fill="#babfc7" stroke="#babfc7" />
                                }
                                fullSymbol={
                                  <Star
                                    size={18}
                                    fill={"#fbbd34"}
                                    stroke={"#fbbd34"}
                                  />
                                }
                              />
                              <RowProdDesc>{variation?.ratings?.averageRating}</RowProdDesc>
                              <RowProdDesc>{variation?.ratings?.reviewsCount}</RowProdDesc>
                              <RowProdDesc>8 FAQ's</RowProdDesc>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                textTransform: "capitalize"
                              }}
                            >
                              <NewsLetterStyle style={{ fontWeight: "600" }}>
                                Brand:
                              </NewsLetterStyle>
                              <DetProdItem>{variation?.attributes?.brand || <Skeleton />}</DetProdItem>
                            </div>
                          </div>
                          {/* social share */}
                          <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', gap: '5px' }}>
                            <CiHeart size={25} />
                            <AiOutlineLike size={25} />
                            <CiShare2 size={25} onClick={toggleDropdown} style={{ cursor: 'pointer' }} />

                            {dropdownVisible && (
                              <div style={dropdownStyles}>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><FaPinterest size={13} color={'#CB1F27'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://www.pinterest.com', '_blank')} style={optionStyles}>Pinterest</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><BsTwitterX size={13} color={'#000000'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://twitter.com', '_blank')} style={optionStyles}>Twitter</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><FaFacebook size={13} color={'#1877F2'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://www.facebook.com', '_blank')} style={optionStyles}>Facebook</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><img src={mail} size={13} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.location.href = 'mailto:?subject=Check this out&body=Your message here'} style={optionStyles}>Email</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><IoMdLink size={15} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={copyLink} style={optionStyles}>Copy Link</div></Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                          }}
                        >
                          <NewsLetterStyle style={{ fontWeight: "600" }}>
                            Color:{" "}
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <DetProdItem>
                              {selectedColor
                                ? colorNames[selectedColor]
                                : "select color"}
                            </DetProdItem>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                              }}
                            >
                              {Object.keys(colorNames).map((color) => (
                                <div
                                  key={color}
                                  style={{
                                    width:
                                      selectedColor === color ? "37px" : "31px",
                                    height:
                                      selectedColor === color ? "24px" : "20px",
                                    backgroundColor: color,
                                    borderRadius: "3px",
                                    //  border: selectedColor === color ? `1px solid ${selectedColor}` : 'none',
                                    cursor: "pointer",
                                    margin: "5px",
                                  }}
                                  onClick={() => handleColorSelection(color)}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                          }}
                        >
                          <NewsLetterStyle style={{ fontWeight: "600" }}>
                            Size:{" "}
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <DetProdItem>
                              {selectedSize ? sizeNames[selectedSize] : "select"}
                            </DetProdItem>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                              }}
                            >
                              {Object.keys(sizeNames).map((size) => (
                                <div
                                  key={size}
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    backgroundColor:
                                      selectedSize === size
                                        ? "#FBBD34"
                                        : "lightgrey",
                                    borderRadius: "3px",
                                    border:
                                      selectedSize === size
                                        ? "none"
                                        : "1px solid transparent",
                                    cursor: isAvailable(size)
                                      ? "pointer"
                                      : "not-allowed",
                                    margin: "5px",
                                    opacity: isAvailable(size) ? 1 : 0.5, // Dim the unavailable items
                                    color:
                                      selectedSize === size ? "white" : "black", // Text color logic
                                  }}
                                  onClick={() =>
                                    isAvailable(size) && handleSizeSelection(size)
                                  }
                                >
                                  {sizeNames[size]}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <NewsLetterStyle
                            style={{ fontWeight: "600", marginRight: "8px" }}
                          >
                            Quantity:
                          </NewsLetterStyle>
                          <button
                            onClick={decreaseQuantity}
                            style={{
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#D9D9D9",
                              color: "white",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            -
                          </button>
                          <span style={{ margin: "0 8px" }}>{quantity}</span>
                          <button
                            onClick={increaseQuantity}
                            style={{
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#D9D9D9",
                              color: "white",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            +
                          </button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <NewsLetterStyle
                            style={{ fontWeight: "600", marginRight: "8px" }}
                          >
                            Promotions:
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={togglePopover}
                            id="PopoverLegacy"
                            ref={toggleRef}
                          >
                            <LuTicket size={25} style={{ color: "#FBBD34" }} />{" "}
                            <FaAngleDown />
                          </div>

                          <Popover
                            placement="bottom"
                            isOpen={popoverOpen}
                            target="PopoverLegacy"
                            trigger="legacy"
                            toggle={togglePopover}
                            ref={popoverRef}
                            popperClassName={styles.customPopover}
                          // style={{ minWidth: "385px" }}
                          >
                            <PopoverBody
                            // style={{ minWidth: "385px" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-evenly",
                                  borderBottom: "1px solid #D9D9D9",
                                }}
                              >
                                <FilterH
                                  onClick={() => handlePromoChange("promotions")}
                                  style={{
                                    cursor: "pointer",
                                    color:
                                      selectedPromo === "promotions"
                                        ? "#EC7426"
                                        : "black",
                                  }}
                                >
                                  Promotions
                                </FilterH>
                                <FilterH
                                  onClick={() => handlePromoChange("coupons")}
                                  style={{
                                    cursor: "pointer",
                                    color:
                                      selectedPromo === "coupons"
                                        ? "#EC7426"
                                        : "black",
                                  }}
                                >
                                  Coupons
                                </FilterH>
                              </div>
                              {selectedPromo === "promotions" && (
                                <div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#FBBD34",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#FDF9D8",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={coupon}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#FBBD34",
                                              }}
                                            >
                                              30% off
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#41B8E4",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#E3F7FF",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={delivery}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#41B8E4",
                                              }}
                                            >
                                              Free Delivery
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                              backgroundColor: "#41B8E4",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {selectedPromo === "coupons" && (
                                <div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#FBBD34",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#FDF9D8",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={coupon}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#FBBD34",
                                              }}
                                            >
                                              30% off
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* <button style={closeButtonStyles} onClick={togglePopover}>Close</button> */}
                            </PopoverBody>
                          </Popover>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "11px",
                            gap: "10px",
                          }}
                        >
                          <RowButton
                            type="button"
                            block
                            color="light-primary"
                            style={{
                              backgroundColor: "#FBBD34",
                              width: "100%",
                            }}
                          >
                            ADD TO CART
                          </RowButton>
                          <RowButton
                            type="button"
                            block
                            color="light-primary"
                            style={{
                              backgroundColor: "#41B8E4",
                              width: "100%",
                            }}
                          >
                            BUY NOW
                          </RowButton>
                        </div>
                      </div>
                    ) : (
                      <div className={styles.productInfo}>
                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div className="d-flex align-items-center">
                              <RowPriceOrange>$33.99</RowPriceOrange> &nbsp; &nbsp;
                              <RowPrice>
                                <strike>$49.99</strike>
                              </RowPrice>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Rating
                                readonly={true}
                                initialRating={fetchedProduct?.ratings?.averageRating}
                                emptySymbol={
                                  <Star size={18} fill="#babfc7" stroke="#babfc7" />
                                }
                                fullSymbol={
                                  <Star
                                    size={18}
                                    fill={"#fbbd34"}
                                    stroke={"#fbbd34"}
                                  />
                                }
                              />
                              <RowProdDesc>{fetchedProduct?.ratings?.averageRating}</RowProdDesc>
                              <RowProdDesc>{fetchedProduct?.ratings?.reviewsCount}</RowProdDesc>
                              <RowProdDesc>8 FAQ's</RowProdDesc>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <NewsLetterStyle style={{ fontWeight: "600" }}>
                                Brand:
                              </NewsLetterStyle>
                              <DetProdItem>{fetchedProduct?.brand?.brandName || <Skeleton />}</DetProdItem>
                            </div>
                          </div>
                          {/* social share */}
                          <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                            <CiHeart size={25} />
                            <AiOutlineLike size={25} />
                            <CiShare2 size={25} onClick={toggleDropdown} style={{ cursor: 'pointer' }} />

                            {dropdownVisible && (
                              <div style={dropdownStyles}>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><FaPinterest size={13} color={'#CB1F27'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://www.pinterest.com', '_blank')} style={optionStyles}>Pinterest</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><BsTwitterX size={13} color={'#000000'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://twitter.com', '_blank')} style={optionStyles}>Twitter</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><FaFacebook size={13} color={'#1877F2'} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.open('https://www.facebook.com', '_blank')} style={optionStyles}>Facebook</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><img src={mail} size={13} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={() => window.location.href = 'mailto:?subject=Check this out&body=Your message here'} style={optionStyles}>Email</div></Col>
                                </Row>
                                <Row flex>
                                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><IoMdLink size={15} /></Col>
                                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><div onClick={copyLink} style={optionStyles}>Copy Link</div></Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                          }}
                        >
                          <NewsLetterStyle style={{ fontWeight: "600" }}>
                            Color:{" "}
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <DetProdItem>
                              {selectedColor
                                ? colorNames[selectedColor]
                                : "select color"}
                            </DetProdItem>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                              }}
                            >
                              {Object.keys(colorNames).map((color) => (
                                <div
                                  key={color}
                                  style={{
                                    width:
                                      selectedColor === color ? "37px" : "31px",
                                    height:
                                      selectedColor === color ? "24px" : "20px",
                                    backgroundColor: color,
                                    borderRadius: "3px",
                                    //  border: selectedColor === color ? `1px solid ${selectedColor}` : 'none',
                                    cursor: "pointer",
                                    margin: "5px",
                                  }}
                                  onClick={() => handleColorSelection(color)}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                          }}
                        >
                          <NewsLetterStyle style={{ fontWeight: "600" }}>
                            Size:{" "}
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <DetProdItem>
                              {selectedSize ? sizeNames[selectedSize] : "select"}
                            </DetProdItem>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                              }}
                            >
                              {Object.keys(sizeNames).map((size) => (
                                <div
                                  key={size}
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    backgroundColor:
                                      selectedSize === size
                                        ? "#FBBD34"
                                        : "lightgrey",
                                    borderRadius: "3px",
                                    border:
                                      selectedSize === size
                                        ? "none"
                                        : "1px solid transparent",
                                    cursor: isAvailable(size)
                                      ? "pointer"
                                      : "not-allowed",
                                    margin: "5px",
                                    opacity: isAvailable(size) ? 1 : 0.5, // Dim the unavailable items
                                    color:
                                      selectedSize === size ? "white" : "black", // Text color logic
                                  }}
                                  onClick={() =>
                                    isAvailable(size) && handleSizeSelection(size)
                                  }
                                >
                                  {sizeNames[size]}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <NewsLetterStyle
                            style={{ fontWeight: "600", marginRight: "8px" }}
                          >
                            Quantity:
                          </NewsLetterStyle>
                          <button
                            onClick={decreaseQuantity}
                            style={{
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#D9D9D9",
                              color: "white",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            -
                          </button>
                          <span style={{ margin: "0 8px" }}>{quantity}</span>
                          <button
                            onClick={increaseQuantity}
                            style={{
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#D9D9D9",
                              color: "white",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            +
                          </button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <NewsLetterStyle
                            style={{ fontWeight: "600", marginRight: "8px" }}
                          >
                            Promotions:
                          </NewsLetterStyle>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={togglePopover}
                            id="PopoverLegacy"
                            ref={toggleRef}
                          >
                            <LuTicket size={25} style={{ color: "#FBBD34" }} />{" "}
                            <FaAngleDown />
                          </div>

                          <Popover
                            placement="bottom"
                            isOpen={popoverOpen}
                            target="PopoverLegacy"
                            trigger="legacy"
                            toggle={togglePopover}
                            ref={popoverRef}
                            style={{ minWidth: "385px" }}
                          >
                            <PopoverBody style={{ minWidth: "385px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-evenly",
                                  borderBottom: "1px solid #D9D9D9",
                                }}
                              >
                                <FilterH
                                  onClick={() => handlePromoChange("promotions")}
                                  style={{
                                    cursor: "pointer",
                                    color:
                                      selectedPromo === "promotions"
                                        ? "#EC7426"
                                        : "black",
                                  }}
                                >
                                  Promotions
                                </FilterH>
                                <FilterH
                                  onClick={() => handlePromoChange("coupons")}
                                  style={{
                                    cursor: "pointer",
                                    color:
                                      selectedPromo === "coupons"
                                        ? "#EC7426"
                                        : "black",
                                  }}
                                >
                                  Coupons
                                </FilterH>
                              </div>
                              {selectedPromo === "promotions" && (
                                <div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#FBBD34",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#FDF9D8",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={coupon}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#FBBD34",
                                              }}
                                            >
                                              30% off
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#41B8E4",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#E3F7FF",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={delivery}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#41B8E4",
                                              }}
                                            >
                                              Free Delivery
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                              backgroundColor: "#41B8E4",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#41B8E4",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {selectedPromo === "coupons" && (
                                <div>
                                  <div
                                    style={{
                                      boxShadow: "-1px 2px 30px 0px #00000012",
                                      paddingTop: "0.5rem",
                                      margin: "0.5rem",
                                      height: "100%",
                                      backgroundColor: "#FBBD34",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#FDF9D8",
                                        padding: "0.5rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "spac-between",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          height={"60px"}
                                          width={"60px"}
                                          src={coupon}
                                        />
                                        <div style={{ width: "100%" }}>
                                          <div>
                                            <LiveProdName
                                              style={{
                                                fontWeight: "600",
                                                color: "#FBBD34",
                                              }}
                                            >
                                              30% off
                                            </LiveProdName>
                                            <div>Min. spent 10$</div>
                                            <div>For selected products</div>
                                          </div>
                                        </div>
                                        <div>
                                          <div>percentage off</div>
                                          <DetCouponApply
                                            style={{
                                              width: "55px",
                                              height: "24px",
                                            }}
                                          >
                                            Apply
                                          </DetCouponApply>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        borderRadius: "0 0 10px 10px",
                                      }}
                                    >
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Expiry Date:
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        30 March- 7 April
                                      </LiveOrgPrice>
                                      <LiveOrgPrice
                                        style={{
                                          color: "#FBBD34",
                                          fontWeight: "400",
                                        }}
                                      >
                                        Code: 2022003
                                      </LiveOrgPrice>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* <button style={closeButtonStyles} onClick={togglePopover}>Close</button> */}
                            </PopoverBody>
                          </Popover>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "11px",
                          }}
                        >
                          <RowButton
                            type="button"
                            block
                            color="light-primary"
                            style={{
                              marginRight: "0.5rem",
                              backgroundColor: "#FBBD34",
                              // maxWidth: "208px",
                              width: "100%",
                            }}
                          >
                            ADD TO CART
                          </RowButton>
                          <RowButton
                            type="button"
                            block
                            color="light-primary"
                            style={{
                              backgroundColor: "#41B8E4",
                              // maxWidth: "208px",
                              width: "100%",
                            }}
                          >
                            BUY NOW
                          </RowButton>
                        </div>

                      </div>
                    )}

                  </div>
                </Col>
              </Row>
              <ProductListingDesc fetchProduct={fetchedProduct} />
            </Col>
            <Col 
              lg={3}
              // style={{ width: "20%" }}
            >
              <div style={{ backgroundColor: '#F2F2F2', padding: '1rem', marginBottom: '1rem' }}>
                <RowPriceOrange style={{ marginBottom: '15px', borderBottom: '1px solid #D9D9D9' }}>$33.99</RowPriceOrange>
                <div style={{ marginBottom: '8px', borderBottom: '1px solid #D9D9D9' }}>
                  <Row className="mb-2">
                    <Col xl='3' lg='4' md='12' sm='12' xs='12'>
                      <DesDeliver>Delivery:</DesDeliver>
                    </Col>
                    <Col xl='9' lg='8' md='12' sm='12' xs='12'>
                      <DesDeliver style={{ fontWeight: '400' }}>All over the Pakistan</DesDeliver>
                    </Col>
                  </Row>
                  <Row className="pb-3 ">
                    <Col xl='3' lg='4' md='12' sm='12' xs='12'>
                      <DesDeliver>Deliver To:</DesDeliver>
                    </Col>
                    <Col xl='9' lg='8' md='12' sm='12' xs='12'>
                      <DesDeliver style={{ fontWeight: '400' }}>Street no. 3, Madina Town, Faisalabad</DesDeliver>
                    </Col>
                  </Row>
                </div>
                <DesDeliver className='py-2'>Shipping:</DesDeliver>
                <DesDeliver className='py-2' style={{ color: '#FBBD34', display: 'flex', justifyContent: 'center' }}>Free Delivery Available</DesDeliver>
                <DesDeliverText style={{ padding: '0.5rem', boxShadow: '4px 4px 10px 0px #EC742640', border: '1px solid #FBBD34', borderRadius: '10px' }}>
                  Enjoy free delivery promotion while minimum spent of <span style={{ color: '#EC7426' }}>35$</span>  with Lorem Ipsum (brand name)
                </DesDeliverText>
                <div>
                  {deliveryOptions.map((option) => (
                    <div
                      key={option.type}
                      className="my-2"
                      style={{
                        padding: '0.5rem',
                        border: selectedOption === option.type ? '1px solid #EC7426' : '1px solid #1A2425',
                        borderRadius: '10px',
                        boxShadow: selectedOption === option.type ? '4px 4px 10px 0px #EC742640' : '',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleOptionClick(option.type)}
                    >
                      <div style={{ fontWeight: '400' }}>{`${option.type}: ${option.price}`}</div>
                      <div style={{ fontWeight: '400' }}>Delivery in <span style={{ color: '#FBBD34' }}>{option.deliveryTime}</span></div>
                    </div>
                  ))}
                </div>
                <div className="py-2" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><DescSold style={{ marginRight: '0.5rem' }}>Sold by:</DescSold> <DesDeliver>Lorem ipsum</DesDeliver></div>

                <DescSold className="py-2">Services</DescSold>

                <Row flex style={{ alignItems: 'center', flexWrap: 'nowrap' }}>
                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><CiCircleCheck size={15} /></Col>
                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><DesDeliverText style={{ fontWeight: '500' }} >Cash on Delivery</DesDeliverText></Col>
                </Row>
                <Row flex style={{ alignItems: 'center' }}>
                  <Col xl='2' lg='2' md='2' sm='2' xs='2'> <AiOutlineLike size={15} /></Col>
                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><DesDeliverText style={{ fontWeight: '500' }} >Authentic product</DesDeliverText></Col>
                </Row>
                <Row flex style={{ alignItems: 'center' }}>
                  <Col xl='2' lg='2' md='2' sm='2' xs='2'><PiKeyReturnThin size={15} /> </Col>
                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><DesDeliverText style={{ fontWeight: '500' }} >12 days easy and free return</DesDeliverText></Col>
                </Row>
                <Row flex style={{ alignItems: 'center' }}>
                  <Col xl='2' lg='2' md='2' sm='2' xs='2'>-</Col>
                  <Col xl='10' lg='10' md='10' sm='10' xs='10'><DesDeliverText style={{ fontWeight: '500' }} >Warranty not available</DesDeliverText></Col>
                </Row>
                <DescSold className="py-2">Rating:</DescSold>

                <Row className="g-2">
                  <Col xl='3' lg='6' className="p-0">
                    <div style={{ border: '1px solid #D9D9D9', padding: '0.5rem', maxHeight: '89px', height: '100%', margin: '2px', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
                      <DescRating>Product Rating</DescRating>
                      <DetProdItem style={{ color: '#FBBD34' }}>5.0</DetProdItem>
                    </div>
                  </Col>
                  <Col xl='3' lg='6' className="p-0">
                    <div style={{ border: '1px solid #D9D9D9', padding: '0.5rem', maxHeight: '89px', height: '100%', margin: '2px', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
                      <DescRating>Positive Seller Feedback</DescRating>
                      <DetProdItem style={{ color: '#FBBD34' }}>100%</DetProdItem>
                    </div>
                  </Col>
                  <Col xl='3' lg='6' className="p-0">
                    <div style={{ border: '1px solid #D9D9D9', padding: '0.5rem', maxHeight: '89px', height: '100%', margin: '2px', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
                      <DescRating>Deliver on time</DescRating>
                      <DetProdItem style={{ color: '#FBBD34' }}>100%</DetProdItem>
                    </div>
                  </Col>
                  <Col xl='3' lg='6' className="p-0">
                    <div style={{ border: '1px solid #D9D9D9', padding: '0.5rem', maxHeight: '89px', height: '100%', margin: '2px', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
                      <DescRating>Chat Response</DescRating>
                      <DetProdItem style={{ color: '#FBBD34' }}>100%</DetProdItem>
                    </div>
                  </Col>
                </Row>

                <div className="pt-3" style={{ display: 'flex', justifyContent: 'center' }}>
                  <DescVisitStore>Visit Store</DescVisitStore>
                </div>

              </div>
              <div className={styles.categoriesLikedProducts}>
                <PeekOtherCategories Peeks={Peeks} />
                <ProductsYouMayLike products={products} down={false} />
              </div>
            </Col>
          </Row>
        </div>

        <div className={styles.sectionHeading}>Similar Products</div>
        <div>
          <SimilarProducts products={products.slice(0, 6)} />
        </div>
        <div className={styles.sectionHeading}>Other Products You May Like</div>
        <div>
          <SimilarProducts products={products.slice(0, 6)} />
          <SimilarProducts products={products.slice(0, 6)} />
          <SimilarProducts products={products.slice(0, 3)} />
        </div>
      </div>
    </>
  );
};

const dropdownStyles = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '80px', // Change this value to move it up/down
  right: '1px',   // Change this value to move it left/right
  backgroundColor: 'white',
  minWidth: '160px',
  boxShadow: '0px 8px 16px rgba(0,0,0,0.2)',
  zIndex: 1,
  padding: '1rem'
};

const optionStyles = {
  // padding: '10px 15px',
  cursor: 'pointer',
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: '#f0f0f0', // Light gray on hover
  },
  color: '#333', // Text color
  fontSize: '16px', // Font size
};


export default ProductListingDetails;